import BobjectFormModal from './bobjectForm.view';

export default BobjectFormModal;
